const loc_en_strings = {
	"Login": {
		"HEADING": "Login FOLBB-ID Platform",
		"LOGIN": "Login",
		"USER": "User",
		"PASSWORD": "Password",
		"LOGIN_FAIL": "Login failed",
		"LOGIN_FIELD_REQUIRED": "The \"Username\" is a mandatory field",
		"PASSWORD_FIELD_REQUIRED": "The \"Password\" is a field is required",
		"FORGOT_PASSWORD": "Forgot password?",
		"DIFFERENT_ACCOUNT": "Sign in with a different account",
		"NO_ACCOUNT": "No account? ",
		"REGISTER": "Register with FOLBB digital",
		"CHANGE_DENIED_TEXT": "Please use e.g. OWA to change your AD-password, or contact your support."
	},
	"Dashboard": {
		"DASHBOARD_TEXT": "Dashboard",
		"ACTION_TEXT": "Actions",
		"CHANGE_PASSWORD_TEXT": "Change Password",
		"MY_APPLICATIONS_TEXT": "My FOLBB Applications",
		"APPLICATIONS_TEXT": "FOLBB Applications",
		"USERS_LIST_TEXT": "User Management"
	},
	"DashboardHome": {
		"ACTION_TEXT": "Dashboard",
		"MY_APPLICATIONS_TEXT": "My FOLBB Applications",
		"APPLICATIONS_TEXT": "FOLBB Applications"
	},
	"Header": {
		"USER_MENU_TEXT": "User Menu",
		"ACTION_TEXT": "Actions",
		"CHANGE_PASSWORD_TEXT": "Change Password",
		"USERS_LIST_TEXT": "User Management",
		"USER_GROUPS": "Roles"
	},
	"Credentials": {
		"OLD_PASSWORD": "Old Password",
		"NEW_PASSWORD": "New Password",
		"CONFIRM_PASSWORD": "Confirm Password",
		"PASS_DO_NOT_MATCH": " The passwords do not match",
		"PASSWORD_FIELD_REQUIRED": "The \"Password\" is a mandatory field",
		"OLD_PASSWORD_FIELD_REQUIRED": "The \"Old Password\" is a mandatory field",
		"SUCCESS_TEXT": "Password has been changed successfully",
		"HEADING": "FOLBB-ID Change Credentials",
		"HELP": "Need Help?",
		"SAVE": "Change",
		"CANCEL": "Cancel",
		"PASSWORD_CHANGE_ERROR": "The data could not be saved. Please try again later",
		"PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
		"PASSWORD_STREIGHT_ERROR": "Password should be minimum 10 symbols, contain lower, upper, special character, digit",
		"PASSWORD_REQUIREMENTS_TEXT": "Password must meet the following requirements:",
		"LOWERCASE_LETTER_TEXT": "At least one letter ",
		"UPPERCASE_LETTER_TEXT": "At least one capital letter",
		"NUMBER_TEXT": "At least one number",
		"SPECIAL_SYMBOL_TEXT": "At least one special symbol",
		"PASSWORD_LENGTH_TEXT": "Be at least 10 characters",
		"PASSWORD_RESTRICTION_TEXT": "The first, last, or user name must not be part of the password",
		"CHANGE_PASSWORD_TEXT": "Change Password",
		"ACTION_TEXT": "Actions",
		"CHANGE_DENIED_TEXT": "Please use e.g. OWA to change your AD-password, or contact your support."
	},
	"CreatePassword": {
		"PASSWORD": "Create a Password",
		"CONFIRM_PASSWORD": "Confirm your Password",
		"PASS_DO_NOT_MATCH": "The passwords do not match",
		"PASSWORD_FIELD_REQUIRED": "The \"Password\" is a mandatory field",
		"SUCCESS_TEXT": "The data has been successfully saved",
		"HEADING": "Create Password",
		"HELP": "Need Help?",
		"SAVE": "Change",
		"CANCEL": "Cancel",
		"PASSWORD_CHANGE_ERROR": "The data could not be saved. Please try again later",
		"PASSWORD_CHANGE_LINK_EXPIRED": "The password reset link is invalid or has expired. Please, request a new link.",
		"PASSWORD_STREIGHT_ERROR": "Password should be minimum 10 symbols, contain lower, upper, special character, digit",
		"PASSWORD_REQUIREMENTS_TEXT": "Password must meet the following requirements:",
		"LOWERCASE_LETTER_TEXT": "At least one letter",
		"UPPERCASE_LETTER_TEXT": "At least one capital letter",
		"NUMBER_TEXT": "At least one number",
		"SPECIAL_SYMBOL_TEXT": "At least one special symbol",
		"PASSWORD_LENGTH_TEXT": "Be at least 10 characters",
		"PASSWORD_RESTRICTION_TEXT": "The first, last, or user name must not be part of the password",
		"PASSWORD_WAS_SET": "The link has already been used to set the password, if you don’t remember the password, please use the reset password function.",
		"OLD_PASSWORD_REQUIRED": "The \"Old password\" is a mandatory field",
		"MMID_CHANGE_PASSWORD": "Change password",
		"OLD_PASSWORD": "Old password",
		"INVALID_OLD_PASSWORD": "Invalid old password",
		"USER_NOT_FOUND_OR_INACTIVE": "User not found or inactive",
		"UNKNOWN_ERROR": "Something went wrong on change password"
	},
	"ForgotPassword": {
		"USER": "E-mail",
		"LOGIN_FAIL": "Please input correct e-mail address",
		"LOGIN_FIELD_REQUIRED": "\"E-mail\" is a mandatory field",
		"HEADING": "Forgot Password",
		"HELP": "Need Help?",
		"SAVE": "Send Reset Password E-mail",
		"CANCEL": "Cancel",
		"SUCCESS_TEXT": "Please check your inbox if you have received an e-mail.",
		"CHANGE_DENIED_TEXT": "Please use e.g. OWA to change your AD-password, or contact your support.",
		"PASSWORD_RESET_TOO_OFTEN": "The password reset function has been used too often, please try again later",
		"RESET_FAILED": "Login failed",
		"LINK_EXPIRED": "Your login link has expired. Please enter your e-mail address to request the login link again.",
		"HEADING_EXPIRED": "Your login link has expired",
		"SAVE_EXPIRED": "Request login link"
	},
	"UsersList": {
		"USERS_LIST_TEXT": "User Management",
		"ACTIVE": "Active",
		"INACTIVE": "Inactive",
		"MMID": "FOLBBID",
		"OU": "Organisational Unit",
		"ORGANIZATION_UNIT": "Organization unit",
		"LANGUAGE": "Language",
		"OPEN_FILTER": "Open filter",
		"CLOSE_FILTER": "Close filter",
		"RESET": "reset",
		"RESET_ALL_FILTERS": "Reset all filters",
		"SEARCH": "Search",
		"STATUS": "Status",
		"GROUPS": "Groups",
		"SHOW_ALL_DETAILS": "Show all details",
		"SHOW_LESS": "Show less",
		"ASCENDING": "Ascending",
		"DESCENDING": "Descending",
		"LIST_END": "End of list",
		"SORT_BY_LASTNAME": "Sort by Last Name",
		"SORT_BY_FIRSTNAME": "Sort by First Name",
		"SORT_BY_EMAIL": "Sort by E-mail",
		"SORT_BY_LANGUAGE": "Sort by preferred language",
		"SORT_BY_STATUS": "Sort by status",
		"SORT_BY_OU": "Sort by OU",
		"SORT_BY_ACCOUNT_NAME": "Sort by Logon Name",
		"EDIT": "Edit",
		"CREATE": "New User",
		"DIGICREATE": "New FOLBB digital User",
		"ACTIVATE": "Activate",
		"DEACTIVATE": "Deactivate",
		"USER_WAS_ACTIVATED": "User was activated",
		"USER_WAS_DEACTIVATED": "User was deactivated",
		"ERROR_USER_ACTIVATION": "Error during user activation",
		"ERROR_USER_DEACTIVATION": "Error during user deactivation",
		"SEND_FORGOT_PW_EMAIL": "Send Forgot Password E-mail",
		"SEND_FORGOT_PW_EMAIL_GENERIC": "Generic Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_DIGI": "FOLBB digital Forgot PW E-mail",
		"COMPANY": "Company",
		"SEND_WELCOME_EMAIL": "Send Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI": "FOLBB digital Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI_NO_PASS": "FOLBB digital Welcome E-mail without PW Button",
		"APPLY_FILTER_FOR_USERS": "Please use the filters, or the search to display the results",
		"GENERATING_EMAIL": "Generating E-mail....",
		"ERROR_EMAIL_GENERATE": "Error generating E-mail....",
		"LOCKED": "Locked",
		"UNLOCK": "Unlock",
		"SET_PASSWORD": "Set Password",
		"PHYSICAL_LOCATION": "Location",
		"REQUIRED": "Required",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
	},
	"EditUser": {
		"USERS_LIST_TEXT": "User Management",
		"USER_WAS_ACTIVATED": "User was activated",
		"USER_WAS_DEACTIVATED": "User was deactivated",
		"ERROR_USER_ACTIVATION": "Error during user activation",
		"ERROR_USER_DEACTIVATION": "Error during user deactivation",
		"LOADING_USER_ERROR": "Loading user error",
		"FIRSTNAME": "First name",
		"LASTNAME": "Last name",
		"EMAIL": "E-mail",
		"ACCOUNT_NAME": "User logon name (pre-windows 2000)",
		"LANGUAGE": "Language",
		"PRINCIPAL_NAME": "User Principal name",
		"OU": "Organization unit",
		"CLASS_DISPLAY_NAME": "Display name",
		"PHONE": "Phone",
		"WEBSITE": "Website",
		"COUNTRY": "Country",
		"STATE": "State",
		"LOCATION": "City",
		"STREET": "Street",
		"POSTAL_CODE": "Postal code",
		"COMPANY": "Company",
		"DEPARTMENT": "Department",
		"PERSONAL_TITLE": "Personal title",
		"MANAGER": "Manager",
		"DESCRIPTION": "Description",
		"GROUPS": "Groups",
		"SAVE": "Save",
		"CANCEL": "Cancel",
		"USER_STATUS": "User status",
		"ACTIVE": "Active",
		"INACTIVE": "Inactive",
		"ACTIVATE": "Activate",
		"DEACTIVATE": "Deactivate",
		"USER_WAS_SAVED": "The user was saved. Updating the servers can take up to 60 sec.<br/> If you see old data, please refresh the page every 30 sec.",
		"UNKNOWN_ERROR": "An unknown error occurred while saving the user",
		"PROXY_ADDRESSES": "Proxy addresses",
		"BROWSE": "Browse",
		"REMOVE": "Remove",
		"ONLY_JPG": "Only jpg images are allowed!",
		"FILE_SIZE": "File size must be less than 100KB!",
		"DIMENSIONS": "Maximum image dimensions are 96x96 pixels!",
		"SEND_FORGOT_PW_EMAIL": "Send Forgot Password E-mail",
		"SEND_FORGOT_PW_EMAIL_GENERIC": "Generic Forgot PW E-mail",
		"SEND_FORGOT_PW_EMAIL_DIGI": "FOLBB digital Forgot PW E-mail",
		"VIRUS_FOUND": "The user could not be saved. Malware has been found in the attachment. The file will not be uploaded. Please contact your system administrator.",
		"VIRUS_SCANNER_NOT_AVL": "The file could not be scanned for malware. Please try again later. If the problem persists contact your system administrator.",
		"INFO": "Info:",
		"SEND_WELCOME_EMAIL": "Send Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI": "FOLBB digital Welcome E-mail",
		"SEND_WELCOME_EMAIL_DIGI_NO_PASS": "FOLBB digital Welcome E-mail without PW Button",
		"SAVING_USER_SPINNER": "Saving user... Please, wait",
		"DUPLICATE_USER": "User already exists",
		"GENERATING_EMAIL": "Generating E-mail....",
		"ERROR_EMAIL_GENERATE": "Error generating E-mail....",
		"UNLOCK": "Unlock",
		"SET_PASSWORD": "Set Password",
		"COST_CENTER": "Cost Center",
		"JOB_TITLE": "Job title",
		"GENDER": "Gender",
		"USER_NOT_FOUND": "User not found",
        "USER_TYPE": "User type",
        "CANONICAL_NAME": "Canonical name"
	},
	"ResendWelcome": {
		"GENERATING_EMAIL": "Generating welcome E-mail...."
	},
	"Shared": {
		"USER_WAS_ACTIVATED": "User was activated",
		"USER_WAS_DEACTIVATED": "User was deactivated",
		"ERROR_USER_ACTIVATION": "Error during user activation",
		"ERROR_USER_DEACTIVATION": "Error during user deactivation",
		"EMAIL_WAS_SENT": "E-mail was sent successfully",
		"EMAIL_NOT_SENT_USER_ACTIVE": "E-mail was not sent. The user already is active. Use the Send Forgot Password E-mail functionality instead",
		"ERROR_EMAIL_SEND": "Error trying to send the e-mail",
		"EMAIL_NOT_SENT_USER_INACTIVE": "E-mail was not sent. The user is inactive. Use the Send FOLBB digital registration E-mail functionality.",
		"PASSWORD_RESET_TOO_OFTEN": "The password reset function has been used too often, please try again later",
		"USER_WAS_UNLOCKED": "User was unlocked",
		"ERROR_UNLOCK_USER": "Error unlocking user"
	}
};

export default loc_en_strings;



// WEBPACK FOOTER //
// ./src/resources/en.js